import { SegmentEvent } from '@/integrations/segment/SegmentEvent';
import { VideoPlayerEventTracking } from '@/modules/core/app/models/segmentevents/VideoPlayerEventTracking';

export class VideoPlayerSegmentWatchedSegmentEvent extends VideoPlayerEventTracking {
  static eventName: string = SegmentEvent.VIDEO_PLAYER_SEGMENT_WATCHED;

  currentTime?: number;

  constructor(eventProperties: Partial<VideoPlayerSegmentWatchedSegmentEvent> = {}) {
    super({ videoIdentifier: eventProperties.videoIdentifier });

    this.currentTime = eventProperties.currentTime;
  }
}
